import { Component } from '@angular/core';
import { TemplateCardBaseComponent } from '@shared/base-components/template-card.base.component';

@Component({
  selector: 'template-card',
  templateUrl: './template-card.component.html',
  styleUrls: ['./template-card.component.scss']
})
export class TemplateCardComponent extends TemplateCardBaseComponent {}
